
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  Gemäss aktuellen Daten ist das Coronavirus auch deutlich ansteckender
  als die Grippe, an der jeweils Millionen erkranken. «Durch die Situation des
  Kreuzfahrtschiffs Diamond Princess vor Japan, wo sich über 20 Prozent der
  über 3000 Passagiere angesteckt haben, wissen wir: Bei der Grippe ist es
  eine Person, die durchschnittlich 1,3 bis 2 weitere Menschen ansteckt, bei
  diesem neuen Coronavirus sind es über zwei. Wirklich verlässliche Zahlen zur
  Ansteckungsrate haben wir aber noch nicht», so Battegay.
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;